import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { collection, doc, onSnapshot } from "firebase/firestore";
import { store } from "@root/store";
import { projects, targets } from "@config/firestore";
import { addDocumentToEMFS, convertDocumentSnapToDocumentsMap, fileDocumentDataToDocumentType } from "./utils";
import { addProjectDocuments, removeDocumentLocally, saveUpdatedDocument } from "./actions";
import { tabClose } from "@comp/project-editor/actions";
import { updateAllTargetsLocally } from "@comp/target-controls/actions";
import { append, assoc, concat, filter, forEach, map, isEmpty, path, prop, propEq, values } from "ramda";
export var subscribeToProjectFilesChanges = function subscribeToProjectFilesChanges(projectUid, dispatch, csound) {
    var unsubscribe = onSnapshot(collection(doc(projects, projectUid), "files"), /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(files) {
            var changedFiles, filesToAdd, filesToRemove, filesToModify, documents, currentReduxDocuments, documentSnaps, documentData, documentDataReady, _currentReduxDocuments, _documentSnaps, _documentData, uids;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1)
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            changedFiles = files.docChanges();
                            filesToAdd = filter(propEq("type", "added"), changedFiles);
                            filesToRemove = filter(propEq("type", "removed"), changedFiles);
                            filesToModify = filter(propEq("type", "modified"), changedFiles);
                            if (!isEmpty(filesToAdd)) {
                                documents = convertDocumentSnapToDocumentsMap(filesToAdd);
                                csound && forEach(function (d) {
                                    if (d.type !== "folder") {
                                        var pathPrefix = (d.path || []).filter(function (p) {
                                            return typeof p === "string";
                                        }).map(function (documentUid) {
                                            return path([documentUid, "filename"], documents);
                                        });
                                        var absolutePath = concat(["/".concat(projectUid)], append(d.filename, pathPrefix)).join("/");
                                        addDocumentToEMFS(projectUid, csound, d, absolutePath);
                                    }
                                }, values(documents));
                                dispatch(addProjectDocuments(projectUid, documents));
                            }
                            if (isEmpty(filesToModify)) {
                                _context3.next = 12;
                                break;
                            }
                            currentReduxDocuments = path(["ProjectsReducer", "projects", projectUid, "documents"], store.getState());
                            documentSnaps = map(prop("doc"), filesToModify);
                            documentData = map(function (d) {
                                return fileDocumentDataToDocumentType(assoc("documentUid", d.id, d.data()));
                            }, documentSnaps); // when using serverData, we get 2 responses,
                            // since we always modify the lastModified timestamp,
                            // it will be null the first time and immedietly not-null
                            documentDataReady = documentData.filter(function (d) {
                                return !!d.lastModified;
                            });
                            _context3.next = 12;
                            return documentDataReady.forEach(/*#__PURE__*/ function () {
                                var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(document_) {
                                    var oldFile, lastPathPrefix, lastAbsolutePath, newPathPrefix, newAbsolutePath;
                                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1)
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    if (!(document_.type !== "folder")) {
                                                        _context.next = 19;
                                                        break;
                                                    }
                                                    oldFile = currentReduxDocuments[document_.documentUid];
                                                    lastPathPrefix = (oldFile.path || []).filter(function (p) {
                                                        return typeof p === "string";
                                                    }).map(function (documentUid) {
                                                        return path([documentUid, "filename"], currentReduxDocuments);
                                                    });
                                                    lastAbsolutePath = concat(["/".concat(projectUid)], append(oldFile.filename, lastPathPrefix)).join("/");
                                                    newPathPrefix = (document_.path || []).filter(function (p) {
                                                        return typeof p === "string";
                                                    }).map(function (documentUid) {
                                                        return path([documentUid, "filename"], currentReduxDocuments);
                                                    });
                                                    newAbsolutePath = concat(["/".concat(projectUid)], append(document_.filename, newPathPrefix)).join("/"); // Handle file moved
                                                    if (!(newAbsolutePath === lastAbsolutePath)) {
                                                        _context.next = 13;
                                                        break;
                                                    }
                                                    _context.t0 = csound;
                                                    if (!_context.t0) {
                                                        _context.next = 11;
                                                        break;
                                                    }
                                                    _context.next = 11;
                                                    return csound.fs.unlink(newAbsolutePath);
                                                case 11:
                                                    _context.next = 17;
                                                    break;
                                                case 13:
                                                    _context.t1 = csound;
                                                    if (!_context.t1) {
                                                        _context.next = 17;
                                                        break;
                                                    }
                                                    _context.next = 17;
                                                    return csound.fs.unlink(lastAbsolutePath);
                                                case 17:
                                                    csound && addDocumentToEMFS(projectUid, csound, document_, newAbsolutePath);
                                                    dispatch(saveUpdatedDocument(projectUid, document_));
                                                case 19:
                                                case "end":
                                                    return _context.stop();
                                            }
                                    }, _callee);
                                }));
                                return function (_x2) {
                                    return _ref2.apply(this, arguments);
                                };
                            }());
                        case 12:
                            if (isEmpty(filesToRemove)) {
                                _context3.next = 20;
                                break;
                            }
                            _currentReduxDocuments = path(["ProjectsReducer", "projects", projectUid, "documents"], store.getState());
                            _documentSnaps = map(prop("doc"), filesToRemove);
                            _documentData = map(function (d) {
                                return fileDocumentDataToDocumentType(assoc("documentUid", d.id, d.data()));
                            }, _documentSnaps);
                            uids = map(prop("documentUid"), _documentData);
                            uids.forEach(function (uid) {
                                dispatch(tabClose(projectUid, uid, false));
                                dispatch(removeDocumentLocally(projectUid, uid));
                            });
                            _context3.next = 20;
                            return _documentData.forEach(/*#__PURE__*/ function () {
                                var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(document_) {
                                    var pathPrefix, absolutePath;
                                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1)
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    if (!(document_.type !== "folder")) {
                                                        _context2.next = 7;
                                                        break;
                                                    }
                                                    pathPrefix = (document_.path || []).filter(function (p) {
                                                        return typeof p === "string";
                                                    }).map(function (documentUid) {
                                                        return path([documentUid, "filename"], _currentReduxDocuments);
                                                    });
                                                    absolutePath = concat(["/".concat(projectUid)], append(document_.filename, pathPrefix)).join("/");
                                                    _context2.t0 = csound;
                                                    if (!_context2.t0) {
                                                        _context2.next = 7;
                                                        break;
                                                    }
                                                    _context2.next = 7;
                                                    return csound.fs.unlink(absolutePath);
                                                case 7:
                                                case "end":
                                                    return _context2.stop();
                                            }
                                    }, _callee2);
                                }));
                                return function (_x3) {
                                    return _ref3.apply(this, arguments);
                                };
                            }());
                        case 20:
                        case "end":
                            return _context3.stop();
                    }
            }, _callee3);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }());
    return unsubscribe;
};
export var subscribeToProjectTargetsChanges = function subscribeToProjectTargetsChanges(projectUid, dispatch) {
    var unsubscribe = onSnapshot(doc(targets, projectUid), /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(target) {
            var _yield$target$data, defaultTarget, targets;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1)
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (target.exists()) {
                                _context4.next = 2;
                                break;
                            }
                            return _context4.abrupt("return");
                        case 2:
                            _context4.next = 4;
                            return target.data();
                        case 4:
                            _yield$target$data = _context4.sent;
                            defaultTarget = _yield$target$data.defaultTarget;
                            targets = _yield$target$data.targets;
                            updateAllTargetsLocally(dispatch, defaultTarget, projectUid, targets);
                        case 8:
                        case "end":
                            return _context4.stop();
                    }
            }, _callee4);
        }));
        return function (_x4) {
            return _ref4.apply(this, arguments);
        };
    }(), function (error) {
        return console.error(error);
    });
    return unsubscribe;
};
export var subscribeToProjectChanges = function subscribeToProjectChanges(projectUid, dispatch, csound) {
    var unsubscribeFileChanges = subscribeToProjectFilesChanges(projectUid, dispatch, csound);
    var unsubscribeTargetChanges = subscribeToProjectTargetsChanges(projectUid, dispatch);
    var unsubscribe = function unsubscribe() {
        return [unsubscribeFileChanges, unsubscribeTargetChanges].forEach(function (u) {
            return u();
        });
    };
    return unsubscribe;
};
